import dayjs from 'dayjs';

/**
 * Helper function to escape CSV cells
 */
const escapeCSVCell = (cell: string): string => {
  if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
    return `"${cell.replace(/"/g, '""')}"`;
  }
  return cell;
};

interface ColumnConfig {
  header: string;
  accessor: any;
}

interface TableRow {
  [key: string]: any;
}

/**
 * Export table data to CSV (Excel-compatible)
 */
export const exportToCSV = (
  data: TableRow[],
  visibleColumns: ColumnConfig[],
  documentType: string
): void => {
  // Prepare headers
  const headers = visibleColumns.map(col => col.header);

  // Prepare rows
  const rows = data.map(row => {
    return visibleColumns.map(col => {
      let value: any;
      if (typeof col.accessor === 'function') {
        value = col.accessor(row);
      } else {
        value = row[col.accessor as keyof TableRow];
      }

      // Convert value to string
      if (value === null || value === undefined) {
        return '-';
      }
      return String(value);
    });
  });

  // Add metadata rows at the top
  const metadata = [
    [`Document Data Export - ${documentType.charAt(0).toUpperCase() + documentType.slice(1)}`],
    [`Generated: ${dayjs().format('YYYY-MM-DD HH:mm:ss')}`],
    [`Total Records: ${data.length}`],
    [], // Empty row for spacing
  ];

  // Combine all data
  const csvContent = [
    ...metadata,
    headers,
    ...rows,
  ]
    .map(row => row.map(cell => escapeCSVCell(cell)).join(','))
    .join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  const filename = `document-data-${documentType}-${dayjs().format('YYYY-MM-DD')}.csv`;
  link.href = url;
  link.download = filename;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up URL
  window.URL.revokeObjectURL(url);
};
